import React, { useState, useEffect } from 'react'

//* Components
import Header from 'components/Header/Header'
import Footer from 'components/Footer/Footer'
import CartView from 'components/CartView/CartView';

//* Styles
import styles from 'styles/Main.module.scss';
import { getCart } from 'api/woocommerce';
import LanguageSwitcher from './components/LanguageSwitcher/LanguageSwitcher';

const App = () => {

  const [ { actualCart }, setActualCart ] = useState({ actualCart: JSON.parse(localStorage.getItem('existing_cart'))})
  const [ { wcCart }, setWcCart ] = useState({ wcCart: null })


  useEffect(() => {
    
    const existing_cart = localStorage.getItem('existing_cart')
    
    if(existing_cart !== undefined && existing_cart !== null && existing_cart !== "") {
      const existing_cart_obj = JSON.parse(localStorage.getItem('existing_cart'))
      setActualCart({ actualCart: existing_cart_obj })
    }

  }, [])

  function handleActualCart(newCart){

    setActualCart({ actualCart: newCart })
    localStorage.setItem('existing_cart', JSON.stringify(newCart))

  }

  useEffect(() => {
    
    ( async function(){
      const new_wc_cart = await getCart()

      if(new_wc_cart !== undefined && new_wc_cart !== null && new_wc_cart.items.length > 0){
        setWcCart({ wcCart: new_wc_cart })
      }

    })()

  }, [])
  
  return (
    <div className={styles["page"]}>
      <Header/>
      <div className={styles["page-container"]}>
        <CartView
          cart={{...actualCart}}
          setCart={handleActualCart}
          wcCart={wcCart}
        />
      </div>
      <LanguageSwitcher/>
      <Footer/>
    </div>
  )
}

export default App